// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_bb9pN  {
  width: 400px;
  height: 100%;
  padding: var( --size-padLarge );
  background-color: var( --color-white );
  border-radius: var( --size-padMedium );
}

.scannerContainer_YLMHI { 
  background-color : var( --color-white ); 
  overflow: hidden !important;
  min-height: 208px;
  height: 100%;
  position: relative;
}

.scannerClose__K_02 { 
  position : absolute;
  top : var( --size-padMedium, 8px );
  right : var( --size-padMedium, 8px );
  color : var( --color-white );
  z-index: 1;
}
  
.scannerUpload_L8ik5 { 
  position : absolute;
  bottom : var( --size-padMedium, 8px );
  left : var( --size-padMedium, 8px );
}

.fullscreen_mTeoX {
  position : absolute;
  bottom : var( --size-padMedium, 8px );
  right : var( --size-padMedium, 8px );
  color : var( --color-white );
  cursor: pointer;
  z-index: 1;
}

.notFound_fxYur {
  width: 311px;
  padding: var( --size-padLarge, 16px );
}

.fullWidth_jSYiF {
  width: 100%;
}

.background_umq8L {
  z-index: 0;
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/group/search/scan/ScanSearch.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,oCAAoC;EACpC,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,oCAAoC;EACpC,4BAA4B;EAC5B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb","sourcesContent":[".content  {\n  width: 400px;\n  height: 100%;\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n  border-radius: var( --size-padMedium );\n}\n\n.scannerContainer { \n  background-color : var( --color-white ); \n  overflow: hidden !important;\n  min-height: 208px;\n  height: 100%;\n  position: relative;\n}\n\n.scannerClose { \n  position : absolute;\n  top : var( --size-padMedium, 8px );\n  right : var( --size-padMedium, 8px );\n  color : var( --color-white );\n  z-index: 1;\n}\n  \n.scannerUpload { \n  position : absolute;\n  bottom : var( --size-padMedium, 8px );\n  left : var( --size-padMedium, 8px );\n}\n\n.fullscreen {\n  position : absolute;\n  bottom : var( --size-padMedium, 8px );\n  right : var( --size-padMedium, 8px );\n  color : var( --color-white );\n  cursor: pointer;\n  z-index: 1;\n}\n\n.notFound {\n  width: 311px;\n  padding: var( --size-padLarge, 16px );\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.background {\n  z-index: 0;\n  height: 100%;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_bb9pN`,
	"scannerContainer": `scannerContainer_YLMHI`,
	"scannerClose": `scannerClose__K_02`,
	"scannerUpload": `scannerUpload_L8ik5`,
	"fullscreen": `fullscreen_mTeoX`,
	"notFound": `notFound_fxYur`,
	"fullWidth": `fullWidth_jSYiF`,
	"background": `background_umq8L`
};
export default ___CSS_LOADER_EXPORT___;
